import { render, staticRenderFns } from "./CommentFeed.vue?vue&type=template&id=2c69c69b&scoped=true&"
import script from "./CommentFeed.vue?vue&type=script&lang=js&"
export * from "./CommentFeed.vue?vue&type=script&lang=js&"
import style0 from "./CommentFeed.vue?vue&type=style&index=0&id=2c69c69b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c69c69b",
  null
  
)

export default component.exports